import React from 'react';
import { observer } from 'mobx-react';
import { IntlShape } from 'react-intl';
import RequestArtifactsPopoverViewModel from '../request-artifacts-popover.viewmodel';
import RequestReplaysMeetingsTableLayout from './replays-meetings-table-layout';
import RequestReplaysSettings from './request-replays-settings';

export interface IReplaysTabProps {
    intl: IntlShape;
    vm: RequestArtifactsPopoverViewModel;
}

export const ReplaysTab = observer(({
    vm,
    intl,
}: IReplaysTabProps) => {


    return (
        <>
            {
                !vm.meetingListEmpty &&
                <>
                    <RequestReplaysSettings
                        intl={intl}
                        reviewRequired={vm.reviewRequired}
                        setReviewRequired={vm.setReviewRequired}
                        placeholderText={vm.placeholderText}
                        getPlaceholderTextLengthError={vm.getPlaceholderTextLengthError}
                        setPlaceholderText={vm.setPlaceholderText}
                        recordingType={vm.replayRecordingType}
                        isWebinarConnectionExist={vm.isReplayWebinarConnectionExist}
                        handleRecordingTypeDropdown={vm.handleRecordingTypeDropdown}
                    />
                    <hr />
                </>
            }
            <RequestReplaysMeetingsTableLayout
                intl={intl}
                eventTimeZone={vm.eventSettings.timeZone}
                meetingsList={vm.replaysMeetingsList}
                isAllMeetingsChecked={vm.isAllMeetingsChecked}
                selectedMeetingIds={vm.replaysSelectedMeetingIds}
                selectedTab={vm.selectedTab}
                handleArtifactMeetingCheckBox={vm.handleArtifactMeetingCheckBox}
            />
        </>
    );
});
